
// src/components/Notification.jsx
import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ModalContext } from '../../../context/ModalContext';
import Popup from '../Popup';
import { subscribeForegroundMessages } from '../../../firebase';
import queryClient from '../../../utils/queryClient';
import { shouldSuppressSubscriptionActivationNotice } from '../../../utils/subscriptionTrial';

const Notification = () => {
  const { setIdModal, idModal } = useContext(ModalContext);
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    return subscribeForegroundMessages((payload) => {
      const note = payload?.notification;
      const title = note?.title || payload?.data?.title || '';
      const body = note?.body || payload?.data?.body || payload?.data?.message || '';
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
      queryClient.invalidateQueries({ queryKey: ['unreadNotifications'] });
      queryClient.invalidateQueries({ queryKey: ['rating'] });
      if (!title && !body) return;
      if (shouldSuppressSubscriptionActivationNotice(title, body, payload)) return;
      toast.success(body ? `${title}: ${body}` : title);
      setNotification({ title, body });
      setIdModal('show-notification');
    });
  }, [setIdModal]);

  return (
    idModal === 'show-notification' && (
      <Popup sx={{ maxWidth: 360 }}>
        <h4>{notification?.title}</h4>
        <p>{notification?.body}</p>
      </Popup>
    )
  );
};

export default Notification;
